import { Phone, Mail, MapPin } from "lucide-react";

const ContactManager = ({ contacts }) => {
  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString("en-GB", {
      day: "numeric",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  return (
    <>
      <h2 className="text-xl font-bold text-[#0A0A0A] mb-6">
        Enquiries ({contacts.length})
      </h2>
      <div className="space-y-4">
        {contacts.map((contact) => (
          <div
            key={contact.id}
            className="bg-white border border-[#E5E5E5] p-4"
            data-testid={`contact-card-${contact.id}`}
          >
            <div className="flex justify-between items-start mb-3">
              <h3 className="font-bold text-[#0A0A0A]">
                {contact.first_name} {contact.last_name}
              </h3>
              <span className="text-xs text-[#525252]">
                {formatDate(contact.created_at)}
              </span>
            </div>
            <div className="space-y-2 text-sm">
              <div className="flex items-center gap-2 text-[#525252]">
                <Mail className="w-4 h-4" />
                <a
                  href={`mailto:${contact.email}`}
                  className="hover:text-[#FF6B00]"
                >
                  {contact.email}
                </a>
              </div>
              {contact.phone && (
                <div className="flex items-center gap-2 text-[#525252]">
                  <Phone className="w-4 h-4" />
                  <a
                    href={`tel:${contact.phone}`}
                    className="hover:text-[#FF6B00]"
                  >
                    {contact.phone}
                  </a>
                </div>
              )}
              {contact.postcode && (
                <div className="flex items-center gap-2 text-[#525252]">
                  <MapPin className="w-4 h-4" />
                  {contact.postcode}
                </div>
              )}
            </div>
            {contact.service && (
              <div className="mt-3">
                <span className="text-xs bg-[#F5F5F5] px-2 py-1 uppercase">
                  {contact.service}
                </span>
              </div>
            )}
            {contact.message && (
              <div className="mt-3 p-3 bg-[#F5F5F5] text-sm text-[#525252]">
                {contact.message}
              </div>
            )}
          </div>
        ))}
        {contacts.length === 0 && (
          <p className="text-center text-[#525252] py-8">No enquiries yet</p>
        )}
      </div>
    </>
  );
};

export default ContactManager;
